import { createContext, useContext } from "react";

import { OrdersState } from "features/Orders/types";

export const OrdersContext = createContext<OrdersState | null>(null);

export const useOrdersContext = (): OrdersState => {
    const state = useContext(OrdersContext);

    if (!state) {
        throw new Error("useOrdersContext должен использоваться внутри Orders");
    }

    return state;
};
